import React from 'react';
import { Award, Users, TrendingUp, Shield } from 'lucide-react';

const AboutSection = () => {
  return (
    <section className="relative bg-white py-32 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute right-0 top-0 w-1/2 h-full opacity-5">
        <img 
          src="https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=1920&q=90"
          alt="Office"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-[7.6923%]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left Column - Image */}
          <div className="relative order-2 lg:order-1">
            <div className="relative h-[600px] overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=1200&q=90"
                alt="Professional Business Team Meeting"
                className="w-full h-full object-cover object-center"
                loading="lazy"
              />
              {/* Overlay Badge */}
              <div className="absolute bottom-8 left-8 bg-white p-6 shadow-2xl max-w-xs border-l-4 border-[#0099FF]">
                <div className="text-5xl font-bold text-[#0099FF] mb-2">15+</div>
                <div className="text-gray-900 font-semibold mb-1 text-lg">Years of Excellence</div>
                <div className="text-gray-600 text-sm">Serving 1500+ businesses across India</div>
              </div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-8 -right-8 w-32 h-32 bg-[#0099FF]/10 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-8 -left-8 w-40 h-40 bg-[#0099FF]/10 rounded-full blur-3xl"></div>
          </div>

          {/* Right Column - Content */}
          <div className="order-1 lg:order-2">
            <div className="inline-block bg-[#0099FF]/10 border border-[#0099FF]/30 px-4 py-2 rounded-none mb-6">
              <span className="text-[#0099FF] text-sm font-medium">ABOUT R S T & CO.</span>
            </div>

            <h2 className="text-4xl md:text-5xl font-semibold text-gray-900 mb-6 tracking-tight leading-tight">
              Building Trusted Relationships Through Expert Financial Guidance
            </h2>
            
            <div className="text-left mb-6">
              <p className="font-heading text-xl font-bold text-gray-900 mb-1">ಆರ್ ಎಸ್ ಟಿ ಅಂಡ್ ಕಂ</p>
              <p className="font-heading text-base text-gray-600">ಸನ್ನದು ಲೆಕ್ಕ ಪರಿಶೋಧಕರು</p>
            </div>

            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Established with a vision to provide comprehensive financial solutions, R S T & Co. has grown to become a trusted partner for over 1500 businesses across India. Our team of experienced chartered accountants brings deep industry knowledge and personalized service to every engagement.
            </p>

            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              From startups seeking incorporation support to established enterprises requiring complex compliance solutions, we deliver excellence with integrity. Our specialization in Startup India operations and foreign company setups sets us apart in the competitive landscape.
            </p>

            {/* Key Metrics */}
            <div className="grid grid-cols-2 gap-6 mb-8">
              <div className="flex items-start gap-4 bg-gray-50 p-4 border-l-4 border-[#0099FF]">
                <div className="w-12 h-12 bg-[#0099FF]/10 flex items-center justify-center flex-shrink-0">
                  <Users className="text-[#0099FF]" size={24} />
                </div>
                <div>
                  <div className="text-3xl font-semibold text-gray-900">1500+</div>
                  <div className="text-sm text-gray-600">Happy Clients</div>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-gray-50 p-4 border-l-4 border-[#0099FF]">
                <div className="w-12 h-12 bg-[#0099FF]/10 flex items-center justify-center flex-shrink-0">
                  <Award className="text-[#0099FF]" size={24} />
                </div>
                <div>
                  <div className="text-3xl font-semibold text-gray-900">100%</div>
                  <div className="text-sm text-gray-600">Satisfaction</div>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-gray-50 p-4 border-l-4 border-[#0099FF]">
                <div className="w-12 h-12 bg-[#0099FF]/10 flex items-center justify-center flex-shrink-0">
                  <TrendingUp className="text-[#0099FF]" size={24} />
                </div>
                <div>
                  <div className="text-3xl font-semibold text-gray-900">200+</div>
                  <div className="text-sm text-gray-600">Startup Projects</div>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-gray-50 p-4 border-l-4 border-[#0099FF]">
                <div className="w-12 h-12 bg-[#0099FF]/10 flex items-center justify-center flex-shrink-0">
                  <Shield className="text-[#0099FF]" size={24} />
                </div>
                <div>
                  <div className="text-3xl font-semibold text-gray-900">15+</div>
                  <div className="text-sm text-gray-600">Years Experience</div>
                </div>
              </div>
            </div>

            {/* Mission Statement */}
            <div className="bg-gradient-to-r from-[#0099FF]/5 to-transparent border-l-4 border-[#0099FF] p-6 shadow-sm">
              <p className="text-gray-700 italic leading-relaxed font-medium">
                "Our mission is to empower businesses with expert financial guidance, enabling them to navigate complex regulations and achieve sustainable growth with confidence."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
